import { useQuestFlags } from './useQuestFlags';

export const useVisibleLink = ({ quest }) => {
  const { isComplete, isCollected } = quest;
  const { isSpecialQuestTask } = useQuestFlags({ quest });

  return !isCollected && isSpecialQuestTask && !isComplete;
};
